import moment from 'moment'
import 'moment/locale/fr'
import 'moment/locale/nl'
import PropTypes from 'prop-types'
import * as translationService from '../../../../services/translationService'
import { DisplayText, ResourceList, Stack, Caption, DisplayCurrency } from '../../../../components'
import React from 'react'

export const pdfStatuses = {
  Checking: 'checking',
  Generating: 'generating',
  Generated: 'generated',
  NotAvailable: 'not_available',
}

export const Application = ({ application, removeFromBroker }) => {
  const [pdfStatus, setPdfStatus] = React.useState(pdfStatuses.Checking)

  const {
    id,
    providedUntil,
    removedByBrokerAt,
    pdfUrl,
    broker,
    property,
    date,
    propertyAddress,
    price,
    step,
    propertyId,
  } = application

  React.useEffect(() => {
    checkAvailability(pdfUrl)
  }, [])

  const checkAvailability = async pdfUrl => {
    if (pdfUrl) {
      setPdfStatus(pdfStatuses.NotAvailable)
    }

    try {
      const response = await fetch(pdfUrl, {
        method: 'GET',
      })
      if (response.status === 200) {
        setPdfStatus(pdfStatuses.Generated)
      } else {
        setPdfStatus(pdfStatuses.Generating)
      }
    } catch (error) {
      setPdfStatus(pdfStatuses.NotAvailable)
    }
  }

  const renderName = () => {
    if (broker.name) {
      return broker.name
    }

    return property.ownerships.map(owner => [owner.account.firstname, owner.account.lastname].join(' ')).join(' & ')
  }

  const getActions = () => {
    let actions = []

    if (pdfUrl) {
      actions = [
        ...actions,
        {
          content: translationService.profileHistoryApplicationPdfStatus(pdfStatus),
          onClick: () => (window.location = pdfUrl),
          primary: false,
          plain: true,
          disabled: pdfStatus !== pdfStatuses.Generated,
        },
      ]
    }

    actions = [
      ...actions,
      {
        content: translationService.profileResendApplication(step),
        url: `/property/${propertyId}/opnieuw`,
        primary: false,
        plain: true,
      },
    ]

    if (removedByBrokerAt) {
      actions.push({
        content: translationService.intakeRemoveByBroker(),
        // onClick: () => {},
        primary: false,
        plain: true,
        disabled: true,
      })
    } else {
      if (moment(providedUntil).isBefore(new Date())) {
        actions.push({
          content: translationService.intakeRemoveApplicationPending(),
          primary: false,
          plain: true,
          disabled: true,
        })
      } else {
        actions.push({
          content: translationService.intakeRemoveApplication(),
          onClick: () => removeFromBroker(id),
          primary: false,
          plain: true,
        })
      }
    }

    return actions
  }

  return (
    <ResourceList.Item actions={property.rentable && getActions()} subdued={!property.rentable}>
      <Stack spacing="tight" vertical={true} className="d-md-flex align-items-center">
        <DisplayText size="extraSmall">
          {moment(date).format('L LT')}: {renderName()}
        </DisplayText>
        <Caption>
          {propertyAddress} - <DisplayCurrency value={Number(price)} />
        </Caption>
      </Stack>
    </ResourceList.Item>
  )
}

Application.propTypes = {
  application: PropTypes.object,
  removeFromBroker: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/views/Profile/components/Application/Application.js